// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"31":"lucky-draws","649":"page-not-found","801":"rewards","962":"home"}[chunkId] + "." + {"31":"28077616","649":"7944c0d4","801":"2776731b","962":"b4be0936"}[chunkId] + ".css";
};